import React from "react"

export class Knob {
  static renderKnob = (state, value, focus) => {
    if (state !== "active" && !focus) {
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="slider-knob"
          style={{ left: `${value}%` }}
        >
          <g filter="url(#filter0_d_544_7651)">
            <circle
              cx="20"
              cy="16"
              r="12"
              fill="white"
            />
          </g>
          <circle
            cx="20"
            cy="16"
            r="8"
            className="knob-circle"
          />
          <defs>
            <filter
              id="filter0_d_544_7651"
              x="0"
              y="0"
              width="40"
              height="40"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood
                floodOpacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="4" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.08 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_544_7651"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_544_7651"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )
    } else {
      return (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="slider-knob"
          style={{ left: `${value}%` }}
          id="knob"
        >
          <g
            opacity="0.32"
            filter="url(#filter0_d_623_526)"
            className={focus ? "knob-focus" : ""}
          >
            <circle
              cx="24"
              cy="20"
              r="16"
              className={"knob-circle--active"}
            />
          </g>
          <circle
            cx="24"
            cy="20"
            r="12"
            fill="white"
          />
          <circle
            cx="24"
            cy="20"
            r="8"
            className="knob-circle"
          />
          <defs>
            <filter
              id="filter0_d_623_526"
              x="0"
              y="0"
              width="48"
              height="48"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood
                floodOpacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="4" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.08 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_623_526"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_623_526"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )
    }
  }
}
